shadow$provide[246] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Grid:{enumerable:true, get:function() {
  return Grid;
}}});
var UAxis = require("../../../util/axis.js");
var UJS = require("../../../util/js.js");
var require$_DOT__DOT__SLASH__DOT__DOT__SLASH_primitive_DOT_js = require("../../primitive.js");
class Grid extends require$_DOT__DOT__SLASH__DOT__DOT__SLASH_primitive_DOT_js.Primitive {
  static initClass() {
    this.traits = ["node", "object", "visible", "style", "line", "grid", "area", "position", "origin", "shade", "axis:x", "axis:y", "scale:x", "scale:y", "span:x", "span:y",];
    this.defaults = {width:1, zBias:-2,};
  }
  constructor(node, context, helpers) {
    super(node, context, helpers);
    this.axes = null;
  }
  make() {
    let axis;
    let mask = this._helpers.object.mask();
    const material = this._helpers.shade.pipeline() || false;
    axis = (first, second, transpose) => {
      let position;
      const detail = this._get(first + "axis.detail");
      const samples = detail + 1;
      const resolution = 1 / detail;
      const strips = this._helpers.scale.divide(second);
      const buffer = this._renderables.make("dataBuffer", {width:strips, channels:1,});
      const positionUniforms = {gridPosition:this._attributes.make(this._types.vec4()), gridStep:this._attributes.make(this._types.vec4()), gridAxis:this._attributes.make(this._types.vec4()),};
      const values = {gridPosition:positionUniforms.gridPosition.value, gridStep:positionUniforms.gridStep.value, gridAxis:positionUniforms.gridAxis.value,};
      const p = position = this._shaders.shader();
      if (transpose != null && mask != null) {
        mask = this._helpers.position.swizzle(mask, transpose);
      }
      p.require(buffer.shader(this._shaders.shader(), 2));
      p.pipe("grid.position", positionUniforms);
      position = this._helpers.position.pipeline(p);
      const styleUniforms = this._helpers.style.uniforms();
      const lineUniforms = this._helpers.line.uniforms();
      const unitUniforms = this._inherit("unit").getUnitUniforms();
      const uniforms = UJS.merge(lineUniforms, styleUniforms, unitUniforms);
      const line = this._renderables.make("line", {uniforms, samples, strips, position, stroke, join, mask, material,});
      return {first, second, resolution, samples, line, buffer, values};
    };
    const {lineX, lineY, crossed, axes} = this.props;
    const transpose = ["0000", "x000", "y000", "z000", "w000"][axes[1]];
    const {stroke, join} = this.props;
    this.axes = [];
    lineX && this.axes.push(axis("x.", "y.", null));
    lineY && this.axes.push(axis("y.", "x.", crossed ? null : transpose));
    const lines = (() => {
      const result = [];
      for (axis of this.axes) {
        result.push(axis.line);
      }
      return result;
    })();
    this._helpers.visible.make();
    this._helpers.object.make(lines);
    this._helpers.span.make();
    return this._listen(this, "span.range", this.updateRanges);
  }
  unmake() {
    this._helpers.visible.unmake();
    this._helpers.object.unmake();
    this._helpers.span.unmake();
    for (const axis of this.axes) {
      axis.buffer.dispose();
    }
    this.axes = null;
  }
  change(changed, touched, init) {
    if (changed["x.axis.detail"] || changed["y.axis.detail"] || changed["x.axis.factor"] || changed["y.axis.factor"] || changed["grid.lineX"] || changed["grid.lineY"] || changed["line.stroke"] || changed["line.join"] || changed["grid.crossed"] || changed["grid.axes"] && this.props.crossed) {
      return this.rebuild();
    }
    if (touched["x"] || touched["y"] || touched["area"] || touched["grid"] || touched["view"] || touched["origin"] || init) {
      return this.updateRanges();
    }
  }
  updateRanges() {
    const axis = (x, y, range1, range2, axis) => {
      const {second, resolution, samples, line, buffer, values} = axis;
      let min = range1.x;
      let max = range1.y;
      UAxis.setDimension(values.gridPosition, x).multiplyScalar(min);
      UAxis.setDimension(values.gridStep, x).multiplyScalar((max - min) * resolution);
      UAxis.addOrigin(values.gridPosition, axes, origin);
      min = range2.x;
      max = range2.y;
      const ticks = this._helpers.scale.generate(second, buffer, min, max);
      UAxis.setDimension(values.gridAxis, y);
      const n = ticks.length;
      return line.geometry.clip(samples, n, 1, 1);
    };
    const {axes, origin} = this.props;
    const range1 = this._helpers.span.get("x.", axes[0]);
    const range2 = this._helpers.span.get("y.", axes[1]);
    const {lineX, lineY} = this.props;
    if (lineX) {
      axis(axes[0], axes[1], range1, range2, this.axes[0]);
    }
    if (lineY) {
      axis(axes[1], axes[0], range2, range1, this.axes[+lineX]);
    }
    window.cake1 = this.axes[0].buffer;
    window.cake2 = this.axes[1].buffer;
    window.cake3 = this.axes[0];
  }
}
Grid.initClass();

};